import { render } from "./PlansView.vue?vue&type=template&id=3b5d9947"
import script from "./PlansView.vue?vue&type=script&lang=js"
export * from "./PlansView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__